import React from 'react'
import PageHeader from '../components/PageHeader'

const SUPPORT_FORM_URL = 'https://forms.zohopublic.com/avenirsmartbusiness/form/TicketSeguroscontigo/formperma/-_Ndd4gGJmR96QpVO9qskxX4M1tctpxVxdC5VYsIAH4'

export default function ContactSupport() {
  return (
    <PageHeader title="Contact Support" backPath="/">
      <div className="min-h-screen bg-gray-50 p-4 md:p-6">
        <div className="mx-auto max-w-5xl overflow-hidden rounded-xl border border-gray-200 bg-white p-2 shadow-sm md:p-4">
          <iframe
            aria-label="Ticket Seguros contigo"
            title="Ticket Seguros contigo"
            frameBorder="0"
            className="h-[500px] w-full border-0"
            src={SUPPORT_FORM_URL}
          />
        </div>
      </div>
    </PageHeader>
  )
}
